// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"JobSection-module_wrapper_ea842","title":"JobSection-module_title_e095e","line":"JobSection-module_line_b45c7","text":"JobSection-module_text_a0b71"};